<template>
    <div v-loading="loading">
        <el-form ref="form" :model="form" label-width="250px" @submit.prevent="onSubmit"
            style="margin: 20px; width: 60%; min-width: 600px">
            <el-form-item label="Notifications Enabled">
                <el-checkbox v-model="form.notifications"></el-checkbox>
            </el-form-item>
            <el-form-item style="margin-top: 10px">
                <el-button type="primary" style="margin-top: 10px" @click="updateUser">Update Profile</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Axios from "axios"
import echarts from "echarts"
import UserService from "@/api/user.service"

export default {
    data() {
        return {
            loading: false,
            form: {
                notifications: false
            },
            user: this.$session.get("User")
        }
    },
    mounted() {
        form.notifications = this.$session.get("User").notifications == 1
    },
    methods: {
        updateUser() {
            UserService.updateUserNotifications(this.user.email, this.form.notifications).then((response) => {
                if (response.data.error == null) {
                    const h = this.$createElement
                    this.$notify({
                        title: "User Profile Updated",
                        message: "Update Success",
                        type: "info"
                    })
                    this.getData();
                }
            })
        },
        getData() {
            //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
            UserService.getUser(this.user.email).then((response) => {
                if (response.data.error == null) {
                    this.$session.set("User", response.data)
                }
            })
        }
    }
}
</script>

<style scoped>
.chart-container {
    width: 100%;
    float: left;
}

/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
    padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// Profile.vue?5fb219e6